import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";
import { toast } from "sonner";

export default function AdminLogin() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back, skipper.");
      navigate("/admin");
    } catch (err) {
      setError(formatApiError(err, "Login failed."));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-slate-100 px-4" data-testid="admin-login-page">
      <form onSubmit={submit} className="card-clean w-full max-w-sm p-8" data-testid="admin-login-form">
        <div className="flex items-center gap-3">
          <img src="/shande-logo.png" alt="Shande III logo" className="h-14 w-14 rounded-full object-contain" />
          <span className="font-display text-2xl font-extrabold uppercase tracking-tight text-slate-900">
            Shande <span className="text-sky-500">III</span>
          </span>
        </div>
        <h1 className="mt-6 flex items-center gap-2 font-display text-2xl font-extrabold uppercase tracking-tight text-slate-900">
          <Lock className="h-5 w-5 text-sky-500" /> Skipper Login
        </h1>
        <p className="mt-1 text-sm text-slate-500">Manage your live booking calendar and orders.</p>

        <div className="mt-6 space-y-4">
          <div>
            <Label htmlFor="admin-email">Email</Label>
            <Input id="admin-email" data-testid="admin-email-input" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="mt-1" autoComplete="email" />
          </div>
          <div>
            <Label htmlFor="admin-password">Password</Label>
            <Input id="admin-password" data-testid="admin-password-input" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required className="mt-1" autoComplete="current-password" />
          </div>
          {error && <p className="text-sm font-medium text-red-600" data-testid="admin-login-error">{error}</p>}
          <Button data-testid="admin-login-submit" type="submit" disabled={loading}
            className="btn-lift w-full rounded-full bg-sky-500 py-5 font-bold text-white hover:bg-sky-600">
            {loading ? "Signing in..." : "Sign In"}
          </Button>
        </div>
      </form>
    </div>
  );
}
